// api/admin.ts
import { apiClient } from "../helpers/api_helper";


export const GetAllUsers = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  role?: boolean;
  isActive?: boolean;
}) => {
  try {

    const response = await apiClient.get('/users', {
      params,
      
    });
    console.log('GetAllUsers response:', response);
    return response;
  } catch (error) {
    console.error('GetAllUsers error:', error);
    throw error;
  }
};

export const GetUserStats = async () => {
  try {

    const response = await apiClient.get('/users/stats' );
    console.log('GetUserStats response:', response);
    return response;
  } catch (error) {
    console.error('GetUserStats error:', error);
    throw error;
  }
};

export const CreateUser = async (data: {
  username: string;
  email: string;
  password: string;
  role: boolean;
}) => {
  try {
    const response = await apiClient.post('/users', data);
    return response.data;
  } catch (error) {
    console.error('CreateUser error:', error);
    throw error;
  }
};

export const UpdateUser = async (id: number, data: {
  username: string;
  email: string;
  role: boolean;
}) => {
  try {

    const response = await apiClient.put(`/users/${id}`, data, );
    return response;
  } catch (error) {
    console.error('UpdateUser error:', error);
    throw error;
  }
};

export const DeleteUser = async (id: number) => {
  try {
    const response = await apiClient.delete(`/users/${id}`, );
    return response.data;
  } catch (error) {
    console.error('DeleteUser error:', error);
    throw error;
  }
};

export const ToggleUserStatus = async (id: number) => {
  try {
    const response = await apiClient.patch(`/users/${id}/toggle-status`, {});
    return response;
  } catch (error) {
    console.error('ToggleUserStatus error:', error);
    throw error;
  }
};

export const AdminChangePassword = async (id: number, data: {
  newPassword: string;
  confirmPassword: string;
}) => {
  try {
    const response = await apiClient.patch(`/users/${id}/change-password`, data, );
    return response;
  } catch (error) {
    console.error('AdminChangePassword error:', error);
    throw error;
  }
};